
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/variants/home/a-swap-reviews-products",
      function () {
        return require("private-next-pages/variants/home/a-swap-reviews-products.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/variants/home/a-swap-reviews-products"])
      });
    }
  